import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBgGradientBlur = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 390,
	height: 214,
	viewBox: "0 0 390 214",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_f_mars)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 86C0 66.1178 16.1178 50 36 50H354C373.882 50 390 66.1177 390 86V214H0V86Z",
			fill: "url(#paint0_linear_mars)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_f_mars",
		x: -50,
		y: 0,
		width: 490,
		height: 264,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 25,
				result: "effect1_foregroundBlur_mars"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_mars",
		x1: 0,
		y1: 132,
		x2: 390,
		y2: 132,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#EC686A" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .25,
				stopColor: "#A9E2F0"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#E98597"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .75,
				stopColor: "#D4CDFB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#BE7678"
			})
		]
	})] })]
});
export default SvgBgGradientBlur;
